import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  public books = [];
  public users: any;
  constructor(private db: AngularFireDatabase, private httpClient: HttpClient) { }

  postProduct(formValue) {

    this.db.list('/Publicidad/Eventos', ref => ref.orderByChild('key').equalTo('-LF2eRf1lHI6X3U6C7Yh'))
  }
  getEvents() {
    return this.db.list('/Eventos').valueChanges();

  }
 getEvent(event_name : string) {
    return this.db.list('/Eventos' ,ref => ref.orderByChild('nombre').equalTo(event_name)).valueChanges();

  }

  getProducts() {
    return this.db.list('/Publicidad').valueChanges();

  }
  getSelectedAds(event_type: any) {
    let type = Number(event_type);
    return this.db.list('/Publicidad/ImagenesPublicitarias', ref => ref.orderByChild('t_type').equalTo(type)).valueChanges();
  }
  getLocation(city: any, desc: any): Observable<any> {
    console.log('city', city, desc);
    const headers = new HttpHeaders()
      .set('x-rapidapi-host', 'tripadvisor1.p.rapidapi.com')
      .set('x-rapidapi-key', 'acbdec2b65mshcda9e5f70912a39p19f856jsn510dd5c5ec73')
      .set('useQueryString', 'true');
    return this.httpClient.get(`${environment.AUTH_SERVER_ADDRESS}/locations/search?location_id=1&limit=1&sort=relevance&offset=0&lang=spa&currency=USD&units=km&query=${city} + ${desc}`, { headers: headers, });
  }
  getWether(lat: any, lon: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('x-rapidapi-host', 'community-open-weather-map.p.rapidapi.com')
      .set('x-rapidapi-key', '0ff4de13e9mshbafda0022c0c6cfp18355ajsn2554e0eb87f4');
    return this.httpClient.get(`https://community-open-weather-map.p.rapidapi.com/weather?lat=${lat}&lon=${lon}&units=metric`, { headers: headers, });
  }
  pushEvent(event: object) {
    return this.db.list('/Eventos').push(event);
  }

  // pushAds() {
  //   let event = {
  //     link: "https://firebasestorage.googleapis.com/v0/b/run...",
  //     src:
  //       "https://firebasestorage.googleapis.com/v0/b/run...",
  //     t_type: 1,
  //     type: 2,
  //   }
  //   return this.db.list('/Publicidad/ImagenesPublicitarias').push(event);
  // }

}